import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Label } from '../../../../../../../CommonComponents/OPL/Label/Label';
import { Input } from '../../../../../../../CommonComponents/OPL/Input/Input';
import { IconButton } from '../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { CampaignAccessDTO } from '../../../../../../api/useCampaignAccessQuery';
import { useSearchAdvisors } from './useSearchAdvisors';

interface Props {
  campaignAccess: CampaignAccessDTO;
  setCampaignAccess(campaignAccess: CampaignAccessDTO): void;
}

export const SearchAdvisors: React.FC<Props> = ({ campaignAccess, setCampaignAccess }) => {
  const { isFindingAdvisors, onSearchTermChange, onFindAdvisors, message } = useSearchAdvisors({
    campaignAccess,
    setCampaignAccess,
  });

  return (
    <Box my="16">
      <Label htmlFor="input--campaigns-search-advisor" mb="4">
        Invite Advisors
      </Label>

      <Box display="flex" gridGap="8">
        <Box flex={1}>
          <Input
            id="campaigns-search-advisor"
            disabled={isFindingAdvisors}
            placeholder="Search advisor email"
            onChange={e => onSearchTermChange(e)}
            onKeyDown={evt => {
              if (evt.key === 'Enter') {
                evt.preventDefault();

                onFindAdvisors();
              }
            }}
            helperText={message?.message}
            formVariant={message?.type}
          />
        </Box>

        <IconButton
          icon="fas fa-search"
          isLoading={isFindingAdvisors}
          onClick={onFindAdvisors}
          aria-label="Search"
        />
      </Box>
    </Box>
  );
};
